import { type ServingSize } from '@hungryroot/rest';
import { PLAN_SERVING_SIZE_WARNING_MODAL_LOCAL_STORAGE_PROP } from './ServingSizeWarningModal';

export function getShowServingSizeWarningModal(
  pairingServingSize: number,
  customerPlanServingSize?: ServingSize
) {
  const showModal =
    window.localStorage.getItem(
      PLAN_SERVING_SIZE_WARNING_MODAL_LOCAL_STORAGE_PROP
    ) === null;

  return (
    customerPlanServingSize !== undefined &&
    pairingServingSize !== customerPlanServingSize &&
    showModal
  );
}
